export const StoritevVrstaEnum = {
  INTERNET_OPTIKA: '2',
  TELEVIZIJA: '4',
  VARNOST: '9',
  TV_PAKETI: '21',
  TRZNI_PAKET: '26',
  INTERNET_PRD: '28',
  INTERNET_SRD: '29',
  NAROCNISKA_VEZAVA: '42',
  HD_TV_VMESNIK: '33',
  SD_TV_VMESNIK: '32',
  WIFI_MESH: '35',
  TV_KARTICE_COAX: '4755',
  T2_KLUB_NAKUP_OPREME: '65',
  NAJEM_PROGRAMSKE_OPREME: '83',
  ENOTE: '57',
  INTERNET_COAX: '117',
  PODATKOVNI_PAKETI: '19',
  NAROCNINA_ZUNANJE_NAPRAVE: 115,
  T2_SCIT: 134
}



// WEBPACK FOOTER //
// ./src/assets/js/Enum/StoritevVrstaEnum.js